import { render, staticRenderFns } from "./download-the-app.vue?vue&type=template&id=a4c61138"
import script from "./download-the-app.vue?vue&type=script&lang=js"
export * from "./download-the-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfImg: require('/usr/src/app/components/tf/img.vue').default})
